export interface MetadataFormat {
  contributors?: Record<string, string>;
  text?: string;
  info?:string; // same as text but both exist
  license?: string;
  refs?: Record<string, string>;
  year?: string;
  album?: string;
}

export default class Metadata {
  contributors: Record<string, string>;

  text: string;

  license: string;

  refs: Record<string, string>;

  year: string;

  album: string;

  constructor(
    data : MetadataFormat,
  ) {
    this.contributors = data.contributors ?? {};
    this.text = data.text ?? data.info ?? '';
    this.license = data.license ?? '';
    this.refs = data.refs ?? {};
    this.year = data.year ?? '';
    this.album = data.album ?? '';
  }

  getAudioInfoShort(): string {
    // Return one line, raw text

    const details = [];

    if (this.contributors?.artist) {
      details.push(`${this.contributors.artist}`);
    }
    if (this.contributors?.performer) {
      details.push(`${this.contributors.performer}`);
    }
    let line = details.join(', ');

    if (this.year) {
      line += ` (${this.year})`;
    }

    if (line) return line;

    // ================================
    if (this.text?.length) {
      return this.text;
    }

    // ================================
    let line2 = '';

    if (this.contributors?.editor) {
      line2 += this.contributors.editor;
    }

    return line2;
  }

  getAudioInfo(): string {
    const lines = [];

    // ==================================
    const details = [];

    if (this.contributors?.artist) {
      details.push(`<b>${this.contributors.artist}</b>`);
    }
    if (this.contributors?.performer) {
      details.push(`<b>${this.contributors.performer}</b>`);
    }
    let line = details.join(', ');

    if (this.year) {
      line += ` (${this.year})`;
    }

    if (line) lines.push(line);

    // ================================
    let line2 = '';

    if (this.contributors?.editor) {
      line2 += this.contributors.editor;
    }

    if (line2) lines.push(line2);

    // ===============================
    if (this.text) {
      lines.push(this.text);
    }

    // ===============================
    return lines.join('<br>');
  }

  getTooltipStr() : string {
    const lines : string[] = [];

    Object.keys(this.contributors).forEach((k) => {
      lines.push(`contributors.${k}: ${this.contributors[k]}`);
    });
    Object.keys(this.refs).forEach((k) => {
      lines.push(`refs.${k} : ${this.refs[k]}`);
    });

    Object.keys(this).filter((k) => k !== 'contributors' && k !== 'refs')
      .forEach((k) => {
        lines.push(`${k} : ${this[k as keyof Metadata] as string}`);
      });
    return lines.join('\n');
  }
}
